import { render, staticRenderFns } from "./invoices.vue?vue&type=template&id=44850b5e&scoped=true"
import script from "./invoices.vue?vue&type=script&lang=js"
export * from "./invoices.vue?vue&type=script&lang=js"
import style0 from "./invoices.vue?vue&type=style&index=0&id=44850b5e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44850b5e",
  null
  
)

export default component.exports